<template>
  <div id="" class="">
      <el-dialog title="创建优惠券" :visible.sync="isShowdialog" :before-close="cancel" width="30%">
        <el-form ref="form" label-width="110px" size="mini" >
          <el-row style="display: flex;justify-content: center">
            <el-col :span="20">
              <el-form-item label="文件夹名称">
                <el-input v-model="groupForm.groupName"></el-input>
              </el-form-item>
              <el-form-item label="文件类型" required>
                <el-select v-model="groupForm.type" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="display:flex;justify-content: flex-end">
            <el-form-item size="mini">
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
export default {
  props:['dialogVisible'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
    },
  },
  data() {
    return {
      isShowdialog: false,
      dialogTitle: '',
      returnTime: '',
      uploading: '',
      options: [{
        value: 'image',
        label: '图片'
      }, {
        value: 'video',
        label: '视频'
      }, {
        value: 'audio',
        label: '音频'
      }],
      groupForm: {
        groupName: '',
        type: ''
      }
    }
  },
  methods:{
    cancel(done){
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowdialog,dialog:'group'})
    },
    async onSubmit() {
      this.uploading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });

      try{
        const coupon = await this.$request.create_group({
          name: this.groupForm.groupName,
          type: this.groupForm.type
        });
        if(coupon.code === 0){
          this.$message('创建文件夹成功');
        }else{
          this.$message(coupon['errMsg']);
        }
      } catch(e) {
        this.$message(e);
      } finally {
        this.uploading.close();
        this.isShowdialog = false;
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'group',refresh:true})
      }
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/CreateGroupDialog.vue